<script setup lang="ts">
import type { NuxtError } from '#app'
import type { PageTitle } from './types/tracking'

const ERROR_MESSAGE_BY_STATUS_CODE: Record<number, string> = {
  404: 'Page not found',
  500: 'Internal server error',
}

const props = defineProps<{ error?: NuxtError }>()

const errorData = computed(() => {
  const { error: e } = props
  const statusCode = e?.status || 500
  const message =
    ERROR_MESSAGE_BY_STATUS_CODE[statusCode] || 'Something went wrong'
  return {
    statusCode,
    message,
  }
})

const metaDataTitle = computed<PageTitle>(
  () => `Error page: ${errorData.value.statusCode}`,
)
const resetError = (): Promise<void> => clearError({ redirect: '/' })

usePage({
  metaTitle: 'Error page',
  metaDescription: errorData.value.message,
  trackingPage: 'Error page',
  trackingPageTitle: metaDataTitle.value,
  shouldIndexPage: false,
  shouldTrackPage: false,
})
</script>

<template>
  <NuxtLayout v-if="error">
    <div
      class="error"
      data-test="error-page"
    >
      <h1>{{ errorData.statusCode }}</h1>
      <p>{{ errorData.message }}</p>
      <UiButton
        data-test="error-page-button"
        type="primary"
        @click="resetError"
      >
        Go back to App Store
      </UiButton>
    </div>
  </NuxtLayout>
</template>

<style lang="scss" scoped>
@use '@/assets/styles/helpers' as *;

.error {
  @extend %flex-column-center;
  @include card-mixin;

  margin: 0 16px;
}

h1 {
  margin: 0;
}
</style>
